<div class="card product-card flex flex-direction-column">
  <div class="header" [style]="headerCss"></div>
  <div class="sub-header">
    @for (badge of product.badges; track badge) {
      <div class="badge sm neutral" [title]="badge">{{badge}}</div>
    }
    <div class="feature-tag">
      <div class="price">{{product.price | currency : 'USD' : 'symbol' : '1.0-0' }}</div>
      <div class="sub">{{product.sub}}</div>
    </div>
  </div>
  <div class="body flex-grow-1">
    <h3 class="title">{{product.title}}</h3>
    <div class="meta">
      <div class="meta-info">
        <span class="badge lg primary-lighten">
          {{product.meta.value | number}}
        </span>
        <span class="label neutral-text">
          {{product.meta.label}}
        </span>
      </div>
      <div>
        <button class="btn pad" (click)="select($event)">Select</button>
      </div>
    </div>
    <ul>
      @for (detail of product.details; track detail) {
        <li class="pen">
          <div [title]="detail" class="details">
            <div class="detail-description">{{detail}}</div>
          </div>
        </li>
      }
    </ul>
  </div>
  <div class="footer">
    <a (click)="showDetails()">See Details</a>
  </div>
</div>
